import React from 'react'
import ScrollTop from './ScrollTop';

const Footer = () => {

    return (
        <footer className="footer">
           <div>A Studio137 Project</div>
           <ScrollTop />
        </footer>
    )
}

export default Footer




// WEBPACK FOOTER //
// ./src/components/Footer.js